module.exports = __webpack_public_path__ + "assets/img/65@3x.aa734aec.png";